import { Action as action } from "./ActionButton";
export { default } from "./Panel";

export type Action = action;
